import React, { Component } from "react";
import { loading, t } from "../components/CustomComponent.js";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import { clearStorageKeepLang } from "../utils/backendMessage";

/**
 * หน้า 403 - เข้าสู่ระบบแล้วแต่ role ไม่มีสิทธิ์ของหน้านั้น
 *
 * แยกจาก notfound.js เพราะสองกรณีนี้คนละเรื่องกัน แต่เดิมถูกเด้งไป 404 เหมือนกันหมด
 * ทำให้แยกไม่ออกว่า "ไม่มีหน้านี้" (โค้ดผิด) หรือ "ไม่มีสิทธิ์" (role ตั้งไม่ครบ)
 */
export default class Forbidden extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    loading(false);
  }

  render() {
    const profile = (() => {
      try {
        return JSON.parse(localStorage.getItem("cm-profile"));
      } catch {
        return null;
      }
    })();

    return (
      <div className="w-100 min-vh-100 background">
        <div className="center w-100 min-vh-100 d-flex justify-content-center align-items-center">
          <div className="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-8 col-xxl-6 mx-auto">
            <div className="p-5 text-center">
              <h1 className="fw-bold mb-4 text-72">403</h1>
              <h3>{t("forbidden_title")}</h3>
              <div className="mb-2 text-secondary">{t("forbidden_detail")}</div>
              <div className="mb-4 text-secondary text-12">{window.location.href}</div>

              {/* บอกว่ากำลังใช้บัญชี/role ไหนอยู่ - ช่วยให้แจ้งผู้ดูแลระบบได้ตรงตัว */}
              {profile && (
                <div className="text-secondary text-12 mb-4">
                  {profile.email || profile.full_name || "-"}
                  {profile.role?.name ? ` · ${profile.role.name}` : ` · ${t("forbidden_no_role")}`}
                </div>
              )}

              <div className="d-flex flex-wrap gap-2 justify-content-center mt-3">
                <button type="button" className="btn btn-dark wpx-200" onClick={() => (window.location.href = "/portal")}>
                  {t("forbidden_back_portal")}
                </button>
                <button
                  type="button"
                  className="btn btn-white border wpx-200"
                  onClick={() => {
                    clearStorageKeepLang();
                    window.location.href = "/";
                  }}
                >
                  {t("logout")}
                </button>
              </div>

              <div className="w-100 text-center mt-4">
                <small className="text-secondary">version {global.version}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
